
import React, { useState } from 'react';
import { Button, Form } from 'react-bootstrap';
import { useAuth } from './../../../context/AuthContext';
import { CgArrowLongLeft } from 'react-icons/cg';
import { IoMailOutline, IoKeyOutline } from 'react-icons/io5';

const ForgotPassword = () => {

  const { resetPassword } = useAuth();
  const [resetLinkSend, setResetLinkSend] = useState(false);
  const [email, setEmail] = useState('');
  const [emailHost, setEmailHost] = useState('');
  const [errorInput, setErrorInput] = useState({});

  const handleForgotPassword = async (event) => {
    event.preventDefault();

    if (email) {
      await resetPassword(email).then(() => {
        let host = email.split('@')[1];
        setEmailHost(host);
        setResetLinkSend(true);
      }).catch((error) => {
        console.log(error.code);
        if (error.code === 'auth/user-not-found') {
          setErrorInput({ ...errorInput, email: 'No account found with this email!' });
        }
        if (error.code === 'auth/too-many-requests') {
          setErrorInput({ ...errorInput, other: 'Something went wrong!' });
        }
      });
    } else {
      if (!email) {
        setErrorInput({ ...errorInput, email: 'Enter your registered email.' });
      }
    }
  }

  return (
    <div className='container'>
      <div className='row align-items-center justify-content-around'>
        <div className='col-md-5 col-lg-4 py-5 my-5'>
          <div className='bg-white border-0 mb-0 card custom-shadow'>
            <div className='forgot-head p-3 text-center'>
              <div className="forgot-head-img">
                {
                  resetLinkSend ?
                    <IoMailOutline size={28} color={`var(--bs-primary)`} />
                    :
                    <IoKeyOutline size={28} color={`var(--bs-primary)`} />
                }
              </div>
              <h3 className="text-center mt-3">{resetLinkSend ? "Check your email" : "Forgot Password?"}</h3>
              {
                resetLinkSend ?
                  <p className='text-secondary'>We sent a password reset link to<br /><span className='text-decoration-underline'>{email}</span></p>
                  :
                  <p className='text-secondary'>No worries, we'll send you reset instructions</p>
              }
            </div>
            {
              resetLinkSend ?
                <div className='p-md-4 pt-md-2 m-md-1 p-3 pb-5'>
                  <a className='btn btn-primary w-100' href={"https://" + emailHost} rel="noreferrer" target="_blank">
                    Open email app
                  </a>
                  <p className='text-center mt-4'>
                    <small>Didn't receive the email? <a href='/forgot-password' onClick={handleForgotPassword}>Click to resend</a></small>
                  </p>
                  <div className='mt-4 d-flex justify-content-center align-items-center'>
                    <div className='back-to-login'>
                      <a href="/login"> <CgArrowLongLeft size={26} /> Back to Login</a>
                    </div>
                  </div>
                </div>
                :
                <div className='p-md-4 m-md-1 p-3 pb-5'>
                  <Form onSubmit={handleForgotPassword}>
                    {
                      errorInput && errorInput.other ?
                        <div className='input-error mb-3 text-center'>{errorInput.other}</div>
                        :
                        null
                    }
                    <Form.Group className="mb-3" controlId="formEmail">
                      <Form.Control
                        type="email"
                        placeholder="Email"
                        onChange={(e) => {
                          setEmail(e.target.value);
                          setErrorInput({ ...errorInput, email: '' })
                        }}
                        className={errorInput.email ? 'border-danger' : null}
                        value={email}
                        isInvalid={errorInput.email}
                      />
                      <Form.Control.Feedback type="invalid">{errorInput.email}</Form.Control.Feedback>
                    </Form.Group>

                    <div className='d-flex align-item-center justify-content-center'>
                      <Button variant="primary" className='w-100' type="submit">
                        Reset Password
                      </Button>
                    </div>
                    <div className='mt-4 d-flex justify-content-center align-items-center'>
                      <div className='back-to-login'>
                        <a href="/login"> <CgArrowLongLeft size={26} /> Back to Login</a>
                      </div>
                    </div>
                  </Form>
                </div>
            }
          </div>
        </div>
      </div>
    </div>
  )
}

export default ForgotPassword;